module.exports = __webpack_public_path__ + "img/report-advance.f49eb8a9.png";